<template>
  <div id="helpCenter" class="helpCenterMain">
    <div class="help-top-bg">
      <p class="help-tip">
        Hi，请问有什么可以帮助您？
      </p>
      <div class="search-box">
        <el-input
          v-model="searchText"
          placeholder="请输入关键字查询"
          class="input-search"
          clearable
          @keyup.enter.native="queryInfo(searchText)"
        >
          <img
            slot="append"
            class="search-img"
            src="@/assets/img/icon-search.png"
            @click="queryInfo(searchText)"
          >
        </el-input>
      </div>
    </div>
    <div class="help-context-box" :style="{ margin: setMtop ? '380px 0 0' : '330px 0 0' }">
      <aside
        v-if="classifysInfo && classifysInfo.length > 0"
        :style="{ 'min-height': minHeight ? minHeight + 100 + 'px' : '400px' }"
      >
        <div id="menu-div" class="context-left-nav" :class="fixNav">
          <div
            v-for="(item, i) in classifysInfo"
            :key="item.id"
            class="line"
            :class="{ active: selectIndex == i }"
            @click="selectChosenClassify(item.id)"
          >
            {{ item.classifyName }}
          </div>
        </div>
        <div id="content">
          <router-view
            :search-key="searchKey"
            :classifys-info="classifysInfo"
            :select-index="classifyId"
          />
        </div>
      </aside>
      <global-empty v-else :label="`暂无数据~`" link-it="3" height="300" />
      <div v-show="loading" v-loading="loading" class="markLoading" />
    </div>
  </div>
</template>

<script>
import { getPortalHelpClassifys, getPageDetail } from '@/api/helpCenter';
import { inherits } from 'util';

let timeId = null;
export default {
  data() {
    return {
      setMtop: false,
      loading: true,
      flag: 1,
      fixedHelpnav: false,
      fixNav: 'helpNavCls',
      classifysInfo: [],
      lastitem: null,
      menuheight: inherits,
      selectIndex: null,
      searchKey: null,
      searchText: null,
      classifyId: '',
      listBoxState: true,
      minHeight: 400
    };
  },
  watch: {
    $route: {
      handler: function() {
        if (this.$route.params.classifyId) {
          console.log('hello man');
          this.selectChosenClassify(this.$route.params.classifyId);
        }
        if (this.$route.query.keyword) {
          this.searchText = this.$route.query.keyword;
          this.searchKey = this.$route.query.keyword;
        }
        this.init();
      },
      immediate: true
    },
    searchKey(val) {
      this.$router.push({
        path: '/help/mainItem',
        query: { keyword: val }
      });
    }
  },
  mounted() {
    this.init();
    window.addEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      if (document.documentElement.scrollTop >= 100) {
        this.setMtop = true;
      } else {
        this.setMtop = false;
      }
    },
    init() {
      this.menuheight = 'inherit';
      this.fixedHelpnav = false;
      window.addEventListener('scroll', this.handleScroll);
      this.getHelpClassifys();
      this.$EventBus.$on('putbackMenu', id => {
        const menuDiv = document.getElementById('menu-div');
        this.fixNav = 'helpNavCls';
        menuDiv.style.top = 108 + 'px';
        this.classifyId = id;
      });
      this.$EventBus.$on('selectMenu', id => {
        this.classifysInfo.forEach((v, j) => {
          this.lastitem = 'id' + j;
          this.minHeight = j * 40;
          if (v.id === id) {
            this.selectIndex = String(j);
          }
        });
      });
    },
    handleScroll() {
      if (this.$route.name !== 'mainItem') return;
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const el = document.querySelector('#helpCenter');
      const menuDiv = document.getElementById('menu-div');
      const offsetTop = el && el.offsetTop;
      this.fixedHelpnav =
        scrollTop > 100 &&
        offsetTop &&
        scrollTop > offsetTop - 44 &&
        el.clientHeight > 400;
      if (this.fixedHelpnav) {
        this.fixNav = 'helpNavCls-fix';
      } else {
        this.fixNav = 'helpNavCls';
      }
      if (menuDiv) menuDiv.style.top = 108 + 'px';
      if (scrollTop + 100 - el.clientHeight > 0 && el.clientHeight > 400) {
        this.fixNav = 'helpNavCls-fix';
        menuDiv.style.top = el.clientHeight - scrollTop + 'px';
      }
      // 滚动右侧事件
      if (this.listBoxState) {
        // productCateforyList是右侧数据
        this.classifysInfo.forEach((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop =
            document.getElementById(`id${i}`) &&
            document.getElementById(`id${i}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight =
            document.getElementById(`id${i}`) &&
            document.getElementById(`id${i}`).offsetHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (
            scrollTop >= offsetTop - scrollHeight &&
            scrollTop <= offsetTop + scrollHeight
          ) {
            // 导航栏背景色选中
            this.selectIndex = String(i);
            this.classifyId = v.id;
          }
        });
      }
    },
    getHelpClassifys() {
      !this.flag-- &&
        getPortalHelpClassifys()
          .then(res => {
            this.classifysInfo = res.data;
            if (this.$route.query.id) {
              getPageDetail(this.$route.query.id)
                .then(res => {
                  this.detailInfo = res.data;
                  this.classifysInfo.forEach((v, j) => {
                    this.lastitem = 'id' + j;
                    this.minHeight = j * 40;
                    if (v.id === this.detailInfo.classifyId) {
                      this.selectIndex = String(j);
                    }
                  });
                })
                .catch(() => {});
            } else {
              this.classifysInfo.forEach((v, j) => {
                this.lastitem = 'id' + j;
                this.minHeight = j * 40;
              });
            }
            this.loading = false;
          })
          .catch(() => {});
    },
    selectChosenClassify(cid) {
      if (this.$route.name !== 'mainItem') {
        this.$router.push({
          name: 'mainItem',
          query: { keyword: this.searchText },
          params: { classifyId: cid }
        });
        return;
      }
      this.classifyId = cid;
      this.classifysInfo.forEach((v, j) => {
        if (v.id === this.classifyId) {
          console.log(this.classifyId);
          this.selectIndex = String(j);
        }
      });
      this.listBoxState = false;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 1000);
    },
    queryInfo(val) {
      this.searchKey = val;
      this.selectIndex = -1;
      this.classifyId = '';
      this.listBoxState = false;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 1000);
      if (this.$route.name !== 'mainItem') {
        this.$router.push({
          path: '/help/mainItem',
          query: { keyword: val }
        });
      }
      setTimeout(() => {
        this.$EventBus.$emit('queryEvent', val);
      }, 200);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.helpCenterMain {
  .help-top-bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding-top: 160px;
    text-align: center;
    height: 470px;
    background: rgb(41,97,215);
    display: block;
    width: 100%;
    background-image: url('~@/assets/img/help-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .help-tip {
      width: 400px;
      height: 30px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin: 0 auto;
      padding-top: 80px;
    }
    .search-box {
      width: 589px;
      height: 40px;
      margin: 80px auto 0;
      /deep/.el-input-group__append {
        padding: 0;
        border-color: #007afc;
        background: #007afc;
      }
      /deep/.el-input--medium .el-input__inner {
        height: 47px;
        line-height: 47px;
        border: 0px solid #dcdfe6;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // color: #CACACA;
      }
      .input-search {
        background: #ffffff;
        border: 1px solid #ececec;
        border-radius: 4px;
        .search-img {
          width: 45px !important;
          height: 40px !important;
        }
      }
    }
  }
  .context-left-nav::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
  .helpNavCls {
    position: static;
  }
  .helpNavCls-fix {
    position: fixed;
  }
  .help-context-box {
    width: 1200px;
    min-height: 880px;
    background-color: #ffffff;
    margin: 20px auto;
    margin-top: 330px;
    padding: 40px;
    .context-left-nav {
      width: 193px;
      background: #fff;
      border: 1px solid #ececec;
      text-align: center;
      // left: 8.5%;
      top: 108px;
      overflow: auto;
      float: left;
      .line {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #ececec;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        &:last-child {
          border-bottom: 0;
        }
        &:hover {
          background-color: #007afc;
          cursor: pointer;
          color: #ffffff;
        }
        &.active {
          background-color: #007afc;
          color: #ffffff;
        }
      }
    }
    .context-right-detail {
      width: 906px;
      // height: 1704px;
      border: 1px solid #ececec;
      .context-item {
        padding: 17px 20px;
        font-family: Microsoft YaHei;
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #555555;
        }

        .more {
          margin: 30px 43%;
          text-align: center;
          .more-text {
            padding: 5px 0;
            border: 1px solid #007afc;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1890ff;
          }
        }
      }
    }
  }
  .markLoading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
